import WhatsappDoubleCheck from "../../assets/icons/WhatsappCheck/WhatsappDoubleCheck";
import WhatsappCheck from "../../assets/icons/WhatsappCheck/WhatsappCheck";
import ExclamationPoint from "../../assets/icons/ExclamationPoint";
import {CONVERSATION_ERROR_CODES} from "../../contants/conversationErrorCodes";
import {Tooltip} from "antd";

export const StatusView = ({ value, errorMessage, isInBubble = false }: { value: string, errorMessage?: string, isInBubble?: boolean }) => {
    if(value === 'READ') {
        return <WhatsappDoubleCheck width={12} height={12} color='#35d835' />
    } else if(value === 'DELIVERED') {
        return <WhatsappCheck width={12} height={12} color='#35d835' />
    } else if((value === 'FAILED' || value === 'UNDELIVERED')) {
        return <div className={`status-view error-container`}>
            <Tooltip className="system-tooltip" title={`${errorMessage && CONVERSATION_ERROR_CODES[errorMessage] || `Error ${errorMessage}`}. \n\nWe'll try to send this message again in 12-24 hours`}>
                <div className="mark"><ExclamationPoint width={10} height={10} color='#fff' /></div>
                {/*{errorMessage ? <div className="error-message"><div>{CONVERSATION_ERROR_CODES[errorMessage] || errorMessage}</div><hr /><div>We'll try to send this message again in 12-24 hours</div></div> : null}*/}
            </Tooltip>
        </div>
    }
    return <div className={`status-view ${value}`} />
}